// extracted by mini-css-extract-plugin
export default {"shapes":"Shapes_shapes__J98-K"};